// extracted by mini-css-extract-plugin
module.exports = {"QuizCreator":"_1_s5yKtVpfY6COUtxpu_Lb"};